export function createDisposers() {
  const stack = [];
  return {
    add(fn) {
      if (typeof fn === "function") {
        stack.push(fn);
      }
    },
    run() {
      for (let i = stack.length; i >= 0; i--) {
        try {
          stack[i]();
        } catch (e) {
          console.error(e);
        }
      }
    },
  };
}
